module.exports = __webpack_public_path__ + "media/images/country_flags/mt-0eccd37460d6e65ab96a0c1ffe5277c5.png";